import { Container } from "./container";

export function Footer() {
  return (
    <div className="absolute bottom-0 min-w-full bg-[#393939]">
      <Container className="h-[200px] flex flex-col justify-center items-center text-white">
        <p className="mb-4 text-center">Copyright: EAST LANDSCAPE AB</p>
        <p className="text-center">
          The site is developed and designed by{" "}
          <a href="https://agilearchitects.se" rel="noreferrer" target="_blank">
            AGILE ARCHITECTS AB
          </a>
        </p>
      </Container>
    </div>
  );
}
